import { httpRequest } from '@common/util/api-common.util';

export default class BlocoApi {
  static apagarBlocoCongelacao(cdLaudo, idLaudoBloco, justificativaText) {
    return httpRequest(
      `congelacao/laudo/${cdLaudo}/bloco/${idLaudoBloco}`,
      'DELETE',
      { justificativa: justificativaText }
    );
  }

  static editarBlocoCongelacao(cdLaudo, idBloco, payload) {
    return httpRequest(`blocos/${idBloco}/laudo/${cdLaudo}`, 'PATCH', {
      payload,
    });
  }

  static getListarDetalhesBloco(cdLaudo, idBloco) {
    return httpRequest(`blocos/${cdLaudo}/bloco/${idBloco}`).then(
      (json) => json.data
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.api.js